import { combineReducers } from 'redux';
import { produce } from 'immer';

// @ts-ignore No types yet
import undoable, { groupByActionTypes, includeAction } from 'redux-undo';
import { CHANGE_HISTORY_LIMIT } from '../constants';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import { THEME_AND_SETTINGS_FETCHED, THEME_SETTINGS_BUFFER_SAVED, THEME_SETTINGS_VARIANT_FETCHED, THEME_SETTINGS_BUFFER_PUBLISHED, THEME_SETTINGS_CHANGE_UNDONE, THEME_SETTINGS_CHANGE_REDONE, THEME_SETTINGS_UPDATED, THEME_SETTINGS_CLEARED, THEME_SETTINGS_RESET, FETCH_THEME_SUCCEEDED, SET_ACTIVE_PRESET, CLEAR_ACTIVE_PRESET } from '../actions/ActionTypes';
import requestStatusFactory from './factories/requestStatusFactory';
import unset from 'hs-lodash/unset';
export const themeSettingsMeta = (state = {}, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_AND_SETTINGS_FETCHED:
    case FETCH_THEME_SUCCEEDED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        //@ts-ignore we should change key in CEUI to payload and remove this
        const payload = action.payload || action.response;
        const {
          themeSettings: {
            id,
            updated
          }
        } = payload;
        return Object.assign({}, draft, {
          id,
          updated
        });
      }
    case THEME_SETTINGS_VARIANT_FETCHED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        const {
          id
        } = action.payload;
        return Object.assign({}, draft, {
          id
        });
      }
    case THEME_SETTINGS_BUFFER_SAVED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return draft;
        }
        const {
          updated,
          fromUniversal
        } = action.payload;
        return Object.assign({}, draft, {
          updated,
          fromUniversal
        });
      }
    default:
      return draft;
  }
});
export const themeSettingsAndBreakpointStyles = (state = {
  activeThemePresetId: undefined,
  breakpointStyles: {},
  values: {}
}, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_AND_SETTINGS_FETCHED:
    case FETCH_THEME_SUCCEEDED:
      {
        //initial state from CEUI moduleReducer is null to avoid {} being converted to immutabl
        if (draft === null) {
          draft = {
            breakpointStyles: {},
            values: {},
            activeThemePresetId: undefined
          };
        }
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) return draft;
        //@ts-ignore we should change key in CEUI to payload and remove this
        const payload = action.payload || action.response;
        const {
          breakpointStyles,
          values
        } = payload.themeSettings;
        const {
          activeThemePresetId
        } = payload.bufferedActiveThemePreset || {};
        Object.assign(draft, {
          breakpointStyles: breakpointStyles || {},
          values,
          activeThemePresetId
        });
        return draft;
      }
    case THEME_SETTINGS_UPDATED:
      {
        const {
          breakpoint,
          themeSettings
        } = action.payload;
        if (breakpoint) {
          draft.breakpointStyles[breakpoint].fieldStyles = themeSettings;
        } else {
          draft.values = themeSettings;
        }
        return draft;
      }
    case THEME_SETTINGS_RESET:
      {
        const {
          breakpoint,
          key: fieldKey
        } = action.payload;
        if (breakpoint) {
          unset(draft, ['breakpointStyles', breakpoint, 'fieldStyles', ...fieldKey]);
        } else {
          unset(draft, ['values', ...fieldKey]);
        }
        return draft;
      }
    case THEME_SETTINGS_CLEARED:
      {
        draft.breakpointStyles = {};
        draft.values = {};
        return draft;
      }
    case THEME_SETTINGS_BUFFER_PUBLISHED:
      {
        if (action.requestStatus !== RequestStatusTypes.SUCCEEDED) return draft;
        const {
          breakpointStyles,
          values
        } = action.payload;
        draft.breakpointStyles = breakpointStyles || {};
        draft.values = values;
        return draft;
      }
    case SET_ACTIVE_PRESET:
      {
        const {
          activeThemePresetId
        } = action;
        draft.activeThemePresetId = activeThemePresetId;
        draft.breakpointStyles = {};
        draft.values = {};
        return draft;
      }
    case CLEAR_ACTIVE_PRESET:
      {
        draft.activeThemePresetId = undefined;
        draft.breakpointStyles = {};
        draft.values = {};
        return draft;
      }
    default:
      return draft;
  }
});
export const undoableThemeSettingsAndBreakpointStyles = undoable(themeSettingsAndBreakpointStyles, {
  limit: CHANGE_HISTORY_LIMIT,
  ignoreInitialState: true,
  redoType: THEME_SETTINGS_CHANGE_REDONE,
  undoType: THEME_SETTINGS_CHANGE_UNDONE,
  filter: includeAction([THEME_AND_SETTINGS_FETCHED, FETCH_THEME_SUCCEEDED, THEME_SETTINGS_UPDATED, THEME_SETTINGS_CLEARED, THEME_SETTINGS_RESET, SET_ACTIVE_PRESET, CLEAR_ACTIVE_PRESET]),
  groupBy: groupByActionTypes([THEME_AND_SETTINGS_FETCHED, THEME_SETTINGS_BUFFER_PUBLISHED])
});
const requestStatus = requestStatusFactory(THEME_AND_SETTINGS_FETCHED);
const contentRequestStatus = requestStatusFactory(FETCH_THEME_SUCCEEDED);
const themeFetchError = (state = null, action) => produce(state, draft => {
  switch (action.type) {
    case THEME_AND_SETTINGS_FETCHED:
      {
        if (action.requestStatus !== RequestStatusTypes.FAILED) return draft;
        const {
          status
        } = action.payload || {};
        return {
          status
        };
      }
    default:
      return draft;
  }
});
export default combineReducers({
  meta: themeSettingsMeta,
  values: undoableThemeSettingsAndBreakpointStyles,
  requestStatus,
  contentRequestStatus,
  themeFetchError
});